import { Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpConfigService } from '../core/httpConfig/httpConfigService';
import { BYPASS_SERVER_ERROR_INTERCEPTOR } from '../core/httpConfig/http-context-tokens';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  api = this.apiConfig.getBaseUrl;


  constructor(private apiConfig: HttpConfigService) { }



  removeOrderById(id): Observable<any> {
    return this.apiConfig.delete(this.api + 'order/' + id, {
      withCredentials: true,
    });
  }

  sendReceipt(id, data): Observable<any> {
    return this.apiConfig.post(this.api + 'order/send-receipt/' + id, data, {
      withCredentials: true,
    });
  }


  getOrderById(id): Observable<any> {
    return this.apiConfig.get(this.api + 'order/admin/' + id, {
      withCredentials: true,
    });
  }

  getOrderByIdForExistence(id): Observable<any> {
    return this.apiConfig.get(this.api + 'order/admin/' + id, {
      withCredentials: true,
      context: new HttpContext().set(BYPASS_SERVER_ERROR_INTERCEPTOR, true),
    });
  }




  updateOrderStatus(order): Observable<any> {
    return this.apiConfig.put(this.api + 'order/update/status', order, {
      withCredentials: true,
    });
  }


}
